import React from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export const AvisoLegal = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Aviso Legal y Condiciones de Uso</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">Titular del sitio web</h2>
          <p className="mb-4">
            Este sitio web (en adelante, el "Sitio Web") es titularidad de <strong>Ulysse Julien Berneau</strong>, con NIE Y5618264E, domicilio en Calle Castillejos 276, SA2A, 08025 Barcelona (España), correo de contacto general info@agencia-ppc.es, teléfono +34 613 076 099 y correo específico para protección de datos rgpd@agencia-ppc.es.
          </p>
          <p className="mb-4">
            <strong>Nombre comercial:</strong> ArrancaYa BCN y Agencia PPC.<br/>
            <strong>Dominio principal:</strong> arrancaya-bcn.es agencia-ppc.es
          </p>
        </section>

        <section className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
          <h2 className="text-xl font-semibold mb-3 text-gray-900">Naturaleza del servicio: plataforma de intermediación</h2>
          <p className="mb-3">
            ArrancaYa BCN es una <strong>plataforma de intermediación y de puesta en contacto</strong> que conecta a los Usuarios que necesitan un servicio de arranque de vehículos con <strong>técnicos y profesionales de asistencia independientes y homologados</strong> que operan por cuenta propia.
          </p>
          <p className="mb-3">
            <strong>Ulysse Julien Berneau es responsable única y exclusivamente del sitio web</strong> (su contenido, su funcionamiento y la puesta en contacto). <strong>No presta directamente el servicio de arranque.</strong> La intervención física, su ejecución, la calidad, los plazos y la facturación corresponden en su totalidad al técnico independiente que atiende cada solicitud.
          </p>
          <p>
            En consecuencia, el Titular del sitio web no asume responsabilidad alguna por la prestación material del servicio ni por los daños, retrasos o incidencias derivados de la intervención de los técnicos independientes, quienes actúan como únicos prestadores y responsables frente al Usuario.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Objeto y ámbito de aplicación</h2>
          <p className="mb-4">
            El presente Aviso legal regula el acceso, navegación y uso del Sitio Web, así como las responsabilidades derivadas de la utilización de sus contenidos (entendiendo por "contenidos" los textos, gráficos, logotipos, marcas, fotografías, software, códigos, diseños, interfaces, así como cualquier otra creación protegida), de conformidad con la normativa española aplicable, en particular la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (LSSI), y demás legislación complementaria.
          </p>
          <p>
            El acceso o utilización del Sitio Web atribuye la condición de Usuario e implica la aceptación plena y sin reservas de todas las disposiciones de este Aviso legal en la versión publicada en cada momento. Si no estás de acuerdo con los términos aquí expuestos, te rogamos te abstengas de usar el Sitio Web.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Condiciones de acceso y uso del Sitio Web</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>El acceso al Sitio Web es, con carácter general, libre y gratuito. No obstante, algunos servicios pueden estar sujetos a contratación y al pago de un precio conforme a las Condiciones de Servicio que se publicarán y aceptarán antes de la contratación.</li>
            <li>El Usuario se compromete a hacer un uso diligente, correcto y lícito del Sitio Web y de sus contenidos, y a no utilizarlos con fines ilícitos, prohibidos o lesivos de derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar, sobrecargar o deteriorar el Sitio Web o impedir su normal utilización.</li>
            <li>El Usuario se compromete a no introducir ni difundir virus informáticos o cualesquiera sistemas físicos o lógicos que sean susceptibles de provocar daños en los sistemas del Titular o de terceros.</li>
            <li>El Usuario se obliga a no emplear identidades falsas ni suplantar la identidad de otros en la utilización del Sitio Web o en la utilización de cualquiera de sus servicios, incluyendo el canal de WhatsApp.</li>
            <li>Cuando el Usuario facilite datos a través de formularios o de WhatsApp, declara que toda la información suministrada es veraz, exacta, actual y completa. El Usuario será el único responsable de los daños y perjuicios que pueda ocasionar al Titular o a terceros por facilitar datos falsos, inexactos, desactualizados o incompletos.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Canales de contacto y contratación</h2>
          <p className="mb-4">
            El Sitio Web puede incluir botones o enlaces que permiten iniciar una conversación a través de WhatsApp con ArrancaYa BCN. WhatsApp es una plataforma de terceros ajena al Titular y se rige por sus propios términos y políticas. Al utilizar dicho canal, el Usuario acepta las condiciones de WhatsApp y entiende que determinadas metadatos y contenidos del chat pueden tratarse por dicho tercero. El Titular no se responsabiliza del funcionamiento o disponibilidad de WhatsApp.
          </p>
          <p>
            Determinadas solicitudes realizadas por WhatsApp podrán requerir la aceptación previa de las Condiciones de Servicio y de la Política de Privacidad del Titular. En estos casos, el Titular informará de ello de forma clara y obtendrá la confirmación expresa del Usuario (p. ej., mediante un "ACEPTO/OK" o marcando una casilla en el formulario de la web) antes de continuar. La solicitud se transmite a un técnico independiente homologado, que es quien contacta al Usuario, presta y factura el servicio por cuenta propia.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Propiedad intelectual e industrial</h2>
          <p>
            Todos los derechos de propiedad intelectual e industrial sobre el Sitio Web y sus contenidos (incluyendo, a título enunciativo, la marca denominativa o figurativa "ArrancaYa BCN", el logotipo, diseños, textos, imágenes, software, bases de datos, estructura, códigos fuente y objeto, así como el diseño gráfico y el "look & feel") son titulares o licenciados por Ulysse Julien Berneau y se encuentran protegidos por la legislación nacional e internacional aplicable.
          </p>
          <p className="mt-3">
            Queda prohibida cualquier forma de reproducción, distribución, comunicación pública, puesta a disposición, transformación o explotación de los contenidos del Sitio Web, más allá de lo estrictamente necesario para la navegación y uso del mismo por parte del Usuario, salvo autorización previa y por escrito del Titular. El uso no autorizado podrá dar lugar a las responsabilidades legalmente establecidas.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">12. Legislación aplicable y jurisdicción</h2>
          <p className="mb-3">Este Aviso legal se rige por la legislación española.</p>
          <ul className="list-disc ml-6 space-y-2">
            <li>Si el Usuario tiene la condición de consumidor/usuario, cualquier controversia se someterá a los Juzgados y Tribunales del domicilio del Usuario o al que resulte imperativo según la normativa de consumo.</li>
            <li>En caso de Usuario que no tenga la condición de consumidor (relaciones B2B/profesionales), las partes se someten, con renuncia expresa a cualquier otro fuero, a los Juzgados y Tribunales de Barcelona capital.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">13. Contacto</h2>
          <p>
            Para cualquier consulta relacionada con el contenido de este Aviso legal, puedes contactar con el Titular en info@agencia-ppc.es o en el teléfono +34 613 076 099. Para cuestiones de privacidad, escribe a rgpd@agencia-ppc.es.
          </p>
        </section>
      </div>
    </div>
  );
};

export const PoliticaPrivacidad = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Política de Privacidad</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Responsable del Tratamiento</h2>
          <p className="mb-4">
            <strong>Responsable:</strong> Ulysse Julien Berneau<br/>
            <strong>NIE:</strong> Y5618264E<br/>
            <strong>Domicilio:</strong> Calle Castillejos 276, SA2A, 08025 Barcelona (España)<br/>
            <strong>Email general:</strong> info@agencia-ppc.es<br/>
            <strong>Email RGPD:</strong> rgpd@agencia-ppc.es<br/>
            <strong>Teléfono:</strong> +34 613 076 099<br/>
            <strong>Nombres comerciales:</strong> ArrancaYa BCN y Agencia PPC
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Datos Personales que Recogemos</h2>
          <p className="mb-3">Recogemos los siguientes tipos de datos personales:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Datos de identificación y contacto:</strong> Nombre, teléfono, email, ubicación del servicio</li>
            <li><strong>Información del vehículo:</strong> Marca, modelo y detalles técnicos necesarios para el servicio</li>
            <li><strong>Datos de navegación:</strong> Dirección IP, cookies, información del dispositivo, páginas visitadas</li>
            <li><strong>Comunicaciones WhatsApp:</strong> Mensajes, metadatos y contenido de las conversaciones para gestión del servicio</li>
            <li><strong>Datos de contratación:</strong> Información necesaria para la prestación del servicio y facturación</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Finalidades del Tratamiento</h2>
          <p className="mb-3">Tratamos sus datos para las siguientes finalidades:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Prestación del servicio:</strong> Arranque de vehículos y servicios relacionados</li>
            <li><strong>Comunicación:</strong> Gestión de consultas, confirmaciones y seguimiento del servicio</li>
            <li><strong>Obligaciones legales:</strong> Cumplimiento de obligaciones contables, fiscales y regulatorias</li>
            <li><strong>Mejora del servicio:</strong> Análisis de calidad y optimización de procesos</li>
            <li><strong>Marketing directo:</strong> Únicamente con consentimiento previo y expreso</li>
            <li><strong>Defensa legal:</strong> Ejercicio y defensa de reclamaciones</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Base Legal del Tratamiento</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Consentimiento:</strong> Para comunicaciones comerciales y cookies no esenciales</li>
            <li><strong>Ejecución contractual:</strong> Para la prestación del servicio solicitado</li>
            <li><strong>Obligación legal:</strong> Para el cumplimiento de obligaciones fiscales y contables</li>
            <li><strong>Interés legítimo:</strong> Para la mejora del servicio y defensa de reclamaciones</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Destinatarios de los Datos</h2>
          <p className="mb-3">Sus datos pueden comunicarse a:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>WhatsApp Inc.:</strong> Para la gestión de comunicaciones a través de su plataforma</li>
            <li><strong>Técnicos y profesionales independientes homologados:</strong> Para poner en contacto al Usuario y permitir la prestación material del servicio solicitado. Estos técnicos actúan como responsables independientes del tratamiento de los datos que reciben para prestar y facturar el servicio.</li>
            <li><strong>Proveedores de servicios:</strong> Gestores telefónicos, servicios de hosting, herramientas de análisis</li>
            <li><strong>Autoridades públicas:</strong> Cuando sea requerido por obligación legal</li>
            <li><strong>Asesores profesionales:</strong> Abogados, gestores, contables cuando sea necesario</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Transferencias Internacionales</h2>
          <p>
            Algunos de nuestros proveedores (como WhatsApp) pueden procesar datos fuera del Espacio Económico Europeo. En estos casos, garantizamos que se aplican las salvaguardas adecuadas según el RGPD, incluyendo cláusulas contractuales tipo o decisiones de adecuación de la Comisión Europea.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Conservación de Datos</h2>
          <p className="mb-3">Los datos se conservarán durante:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Datos contractuales:</strong> Durante la vigencia de la relación y 6 años adicionales para obligaciones legales</li>
            <li><strong>Comunicaciones WhatsApp:</strong> Durante la prestación del servicio y 3 años adicionales</li>
            <li><strong>Datos de marketing:</strong> Hasta la retirada del consentimiento</li>
            <li><strong>Datos de navegación:</strong> Según se especifica en la Política de Cookies</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Derechos del Usuario</h2>
          <p className="mb-3">Puede ejercer los siguientes derechos:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Acceso:</strong> Conocer qué datos tratamos sobre usted</li>
            <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos</li>
            <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos</li>
            <li><strong>Limitación:</strong> Restringir el tratamiento en determinadas circunstancias</li>
            <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
            <li><strong>Oposición:</strong> Oponerse al tratamiento basado en interés legítimo</li>
            <li><strong>Retirada del consentimiento:</strong> En cualquier momento</li>
          </ul>
          <p className="mt-3">
            Para ejercer estos derechos, contacte con rgpd@agencia-ppc.es. También puede presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">9. Medidas de Seguridad</h2>
          <p>
            Aplicamos medidas técnicas y organizativas apropiadas para proteger sus datos personales contra el tratamiento no autorizado o ilícito y contra su pérdida, destrucción o daño accidental, incluyendo cifrado, controles de acceso y formación del personal.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">10. Menores de Edad</h2>
          <p>
            No recogemos intencionalmente datos de menores de 14 años. Si tiene conocimiento de que un menor ha proporcionado datos personales, contacte con nosotros para proceder a su eliminación.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">11. Actualizaciones</h2>
          <p>
            Esta Política de Privacidad puede actualizarse. La versión vigente estará siempre disponible en nuestro sitio web con indicación de la fecha de última modificación.
          </p>
        </section>
      </div>
    </div>
  );
};

export const PoliticaCookies = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Política de Cookies</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. ¿Qué son las cookies?</h2>
          <p>
            Las cookies son pequeños archivos de texto que se almacenan en el dispositivo del usuario cuando visita un sitio web. Permiten que el sitio web recuerde las acciones y preferencias del usuario durante un período de tiempo, para no tener que volver a introducirlas cada vez que regrese al sitio o navegue de una página a otra.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Responsable</h2>
          <p>
            <strong>Responsable:</strong> Ulysse Julien Berneau (ArrancaYa BCN)<br/>
            <strong>Domicilio:</strong> Calle Castillejos 276, SA2A, 08025 Barcelona<br/>
            <strong>Email:</strong> info@agencia-ppc.es<br/>
            <strong>Email RGPD:</strong> rgpd@agencia-ppc.es
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Tipos de Cookies que Utilizamos</h2>
          
          <div className="mb-4">
            <h3 className="text-lg font-medium mb-2 text-gray-800">3.1. Según su finalidad:</h3>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>Cookies técnicas:</strong> Esenciales para el funcionamiento básico del sitio web, permitiendo la navegación y el uso de diferentes opciones o servicios.</li>
              <li><strong>Cookies de preferencias:</strong> Permiten recordar información para personalizar la experiencia de navegación.</li>
              <li><strong>Cookies analíticas:</strong> Recopilan información sobre el uso del sitio web para mejorar su funcionamiento.</li>
              <li><strong>Cookies de marketing:</strong> Utilizadas para mostrar publicidad relevante y medir su eficacia.</li>
            </ul>
          </div>

          <div className="mb-4">
            <h3 className="text-lg font-medium mb-2 text-gray-800">3.2. Según su duración:</h3>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>Cookies de sesión:</strong> Se eliminan cuando se cierra el navegador.</li>
              <li><strong>Cookies persistentes:</strong> Permanecen en el dispositivo durante un período determinado.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-medium mb-2 text-gray-800">3.3. Según su origen:</h3>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>Cookies propias:</strong> Enviadas desde nuestro sitio web.</li>
              <li><strong>Cookies de terceros:</strong> Enviadas desde dominios de terceros (Google Analytics, WhatsApp, etc.).</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Cookies Específicas Utilizadas</h2>
          
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Cookie</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Tipo</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Finalidad</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">cookiesAccepted</td>
                  <td className="border border-gray-300 px-4 py-2">Técnica</td>
                  <td className="border border-gray-300 px-4 py-2">Recordar la aceptación de cookies</td>
                  <td className="border border-gray-300 px-4 py-2">Persistente</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">_ga</td>
                  <td className="border border-gray-300 px-4 py-2">Analítica</td>
                  <td className="border border-gray-300 px-4 py-2">Google Analytics - Distinguir usuarios</td>
                  <td className="border border-gray-300 px-4 py-2">2 años</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">_gid</td>
                  <td className="border border-gray-300 px-4 py-2">Analítica</td>
                  <td className="border border-gray-300 px-4 py-2">Google Analytics - Distinguir usuarios</td>
                  <td className="border border-gray-300 px-4 py-2">24 horas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">_gtm_*</td>
                  <td className="border border-gray-300 px-4 py-2">Analítica</td>
                  <td className="border border-gray-300 px-4 py-2">Google Tag Manager</td>
                  <td className="border border-gray-300 px-4 py-2">Sesión</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Base Legal</h2>
          <p className="mb-3">El tratamiento de datos a través de cookies se basa en:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Consentimiento:</strong> Para cookies analíticas y de marketing</li>
            <li><strong>Interés legítimo:</strong> Para cookies técnicas esenciales para el funcionamiento del sitio</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Gestión de Cookies</h2>
          
          <div className="mb-4">
            <h3 className="text-lg font-medium mb-2 text-gray-800">6.1. Configuración en el sitio web:</h3>
            <p>Puede gestionar sus preferencias de cookies a través del banner que aparece al acceder al sitio web.</p>
          </div>

          <div className="mb-4">
            <h3 className="text-lg font-medium mb-2 text-gray-800">6.2. Configuración del navegador:</h3>
            <p className="mb-2">También puede configurar su navegador para:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Aceptar o rechazar todas las cookies</li>
              <li>Notificarle cuando se reciba una cookie</li>
              <li>Eliminar cookies almacenadas</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-medium mb-2 text-gray-800">6.3. Enlaces de configuración por navegador:</h3>
            <ul className="list-disc ml-6 space-y-1">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" className="text-blue-600 underline">Chrome</a></li>
              <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" className="text-blue-600 underline">Firefox</a></li>
              <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" className="text-blue-600 underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" className="text-blue-600 underline">Internet Explorer</a></li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Consecuencias de Desactivar Cookies</h2>
          <p className="mb-3">Si desactiva las cookies:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li>Algunas funcionalidades del sitio web pueden no funcionar correctamente</li>
            <li>Su experiencia de navegación puede verse afectada</li>
            <li>No podremos personalizar el contenido según sus preferencias</li>
            <li>Los formularios y funciones interactivas pueden no funcionar</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Actualización de la Política</h2>
          <p>
            Esta Política de Cookies puede actualizarse para reflejar cambios en las cookies que utilizamos o por otros motivos operativos, legales o regulatorios. Le recomendamos revisar periódicamente esta política.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">9. Más Información</h2>
          <p className="mb-3">Para más información sobre cookies y privacidad:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li>Contacte con nosotros: rgpd@agencia-ppc.es</li>
            <li>Agencia Española de Protección de Datos: <a href="https://www.aepd.es" target="_blank" className="text-blue-600 underline">www.aepd.es</a></li>
            <li>Información sobre cookies: <a href="https://www.allaboutcookies.org" target="_blank" className="text-blue-600 underline">www.allaboutcookies.org</a></li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export const TerminosCondiciones = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Condiciones Generales de Servicio</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="font-medium text-gray-900 mb-2">ArrancaYa BCN – Ulysse Julien Berneau (NIE Y5618264E)</p>
          <p className="text-sm space-y-1">
            <span className="block"><strong>Domicilio:</strong> Calle Castillejos 276, SA2A, 08025 Barcelona (España)</span>
            <span className="block"><strong>Contacto:</strong> info@agencia-ppc.es · +34 613 076 099</span>
            <span className="block"><strong>Privacidad:</strong> rgpd@agencia-ppc.es</span>
            <span className="block"><strong>Dominio:</strong> arrancaya-bcn.es</span>
          </p>
        </div>

        <p className="text-sm italic">
          Estas Condiciones regulan el uso del sitio web como plataforma de intermediación que pone en contacto al Usuario con técnicos independientes homologados que prestan el servicio de arranque 12 V a domicilio en Barcelona (en adelante, el "Servicio"). El titular del sitio web actúa únicamente como intermediario y no presta directamente el Servicio. Son complementarias al Aviso Legal, a la Política de Privacidad y a la Política de Cookies.
        </p>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Objeto del Servicio</h2>
          <div className="space-y-3">
            <p><strong>1.1.</strong> ArrancaYa BCN es una plataforma de intermediación que pone en contacto al Usuario con técnicos independientes homologados. Son estos técnicos quienes prestan, por cuenta propia, la asistencia de arranque de vehículos mediante equipos de impulso/booster 12 V, el diagnóstico básico de batería y la comprobación de tensión de carga con el motor en marcha. El titular del sitio web no ejecuta, supervisa ni interviene en el Servicio.</p>
            <p><strong>1.2.</strong> <strong>Ámbito:</strong> turismos, SUV y furgonetas ligeras (≤3.500 kg). Vehículos diésel/gasolina con sistema de 12 V.</p>
            <p><strong>1.3.</strong> <strong>Exclusiones:</strong> no se realizan remolques, sustituciones de componentes en vía pública (salvo suministros puntuales acordados), ni intervenciones sobre sistemas de alto voltaje (vehículos eléctricos/híbridos: solo batería auxiliar 12 V). Tampoco se realizan trabajos de mecánica compleja, diagnosis avanzada OBD, ni actuaciones contrarias a la normativa de seguridad vial o a las condiciones del emplazamiento.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Proceso de contratación (WhatsApp-first) y derecho de rechazo</h2>
          <div className="space-y-3">
            <p><strong>2.1.</strong> La solicitud llega por WhatsApp o formulario web (botón WhatsApp). Antes de continuar, el cliente tendrá acceso a estas Condiciones y a la Política de Privacidad.</p>
            <p><strong>2.2.</strong> <strong>Oferta/Resumen:</strong> ArrancaYa BCN enviará por WhatsApp un resumen con: dirección y acceso, tipo de vehículo, precio aplicable (ver §5), ETA estimada, medios de pago y política de cancelación.</p>
            <p><strong>2.3.</strong> <strong>Aceptación:</strong> el contrato se considera perfeccionado cuando el cliente confirma por escrito en el chat (p. ej., "OK", "ACEPTO") o marca la casilla de aceptación en la web.</p>
            <p><strong>2.4.</strong> <strong>Prestación inmediata y desistimiento:</strong> al confirmar, el cliente solicita la prestación inmediata del Servicio y reconoce que, una vez totalmente ejecutado, pierde el derecho de desistimiento legal. Si el Servicio se hubiera iniciado y el cliente ejerciera desistimiento antes de su finalización, abonará la parte proporcional ya prestada y, en su caso, el desplazamiento (§7).</p>
            <p><strong>2.5.</strong> <strong>Derecho a rechazar solicitudes:</strong> ArrancaYa BCN podrá rechazar cualquier solicitud o cancelar una intervención a su sola discreción y en cualquier momento, por motivos de disponibilidad, seguridad, inexistencia de condiciones adecuadas, tipología de vehículo, ubicación, riesgo, incumplimiento de estas Condiciones o cualquier otra causa lícita. En tal caso, si no se ha iniciado el desplazamiento, no habrá cargo alguno.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Cobertura, horarios y ETA</h2>
          <div className="space-y-3">
            <p><strong>3.1.</strong> <strong>Zona prioritaria:</strong> Barcelona ciudad. Zonas limítrofes bajo disponibilidad y posible suplemento por distancia (§5.4).</p>
            <p><strong>3.2.</strong> <strong>Horarios orientativos:</strong> 07:30–22:00 (día) y franja noche/fines de semana bajo tarifa específica.</p>
            <p><strong>3.3.</strong> <strong>ETA:</strong> el tiempo de llegada indicado es estimado (tráfico, climatología, accesos). No constituye compromiso de plazo esencial.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Requisitos de acceso y seguridad</h2>
          <div className="space-y-3">
            <p><strong>4.1.</strong> El cliente garantiza: (a) ubicación exacta del vehículo y accesos practicables; (b) autorización para actuar sobre el vehículo; (c) condiciones seguras de trabajo (iluminación mínima, ausencia de riesgos).</p>
            <p><strong>4.2.</strong> En aparcamientos o emplazamientos especiales, el cliente indicará altura y normas internas.</p>
            <p><strong>4.3.</strong> Si se aprecia riesgo para personas, bienes o instalaciones, ArrancaYa BCN podrá no intervenir o interrumpir la actuación (ver §2.5).</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Precios, suplementos e impuestos</h2>
          <div className="space-y-3">
            <p><strong>5.1.</strong> <strong>Tarifa base orientativa de la red de técnicos (vigente desde enero 2026)</strong> publicada en la web. Los precios finales los fijan y aplican los técnicos independientes que prestan el Servicio:</p>
            <ul className="list-disc ml-8 space-y-1">
              <li>Día (08:00–22:00, lunes a viernes): <strong>69 € IVA incl.</strong></li>
              <li>Noche (22:00–08:00) y fines de semana/festivos: <strong>99 € IVA incl.</strong></li>
            </ul>
            <p><strong>5.2.</strong> <strong>Incluye:</strong> desplazamiento dentro de la zona estándar, diagnóstico básico (tensión), hasta 2 intentos de arranque y hasta 15 minutos de actuación in situ.</p>
            <p><strong>5.3.</strong> <strong>Si no arranca, es GRATIS:</strong> cuando, tras la actuación conforme al §1 y §4, el vehículo no llegue a arrancar, no se cobra nada (0 €).</p>
            <p><strong>5.4.</strong> <strong>Suplementos aplicables:</strong></p>
            <ul className="list-disc ml-8 space-y-1">
              <li><strong>Aeropuerto El Prat:</strong> +25 € debido al desplazamiento y acceso especial.</li>
              <li><strong>Distancia fuera del radio estándar</strong> (&gt;7 km desde Plaça Catalunya): +1 €/km A/R (informado en el resumen previo).</li>
            </ul>
            <p><strong>5.5.</strong> No se aplican suplementos por acceso difícil, vehículo grande ni por tiempo de espera.</p>
            <p><strong>5.6.</strong> Todos los precios incluyen IVA salvo indicación expresa. Rigen las tarifas publicadas al momento de la aceptación.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Medios de pago y factura</h2>
          <div className="space-y-3">
            <p><strong>6.1.</strong> Bizum, tarjeta (TPV) o efectivo.</p>
            <p><strong>6.2.</strong> El cobro y la facturación los realiza directamente el técnico independiente que presta el Servicio, con los datos facilitados por el cliente. Para facturas a empresas/autónomos, el cliente aportará datos fiscales correctos. El titular del sitio web no interviene en el cobro ni emite factura por el Servicio.</p>
            <p><strong>6.3.</strong> El impago faculta a ArrancaYa BCN a reclamar cantidades debidas y gastos asociados.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Cancelaciones, ausencias y desplazamiento</h2>
          <div className="space-y-3">
            <p><strong>7.1.</strong> Cancelación sin coste si se comunica antes de que el técnico inicie el desplazamiento.</p>
            <p><strong>7.2.</strong> Si el técnico ya se ha desplazado y el Servicio se cancela por el cliente, por imposibilidad de acceso, ausencia en el lugar o dirección incorrecta, se facturará un forfait de desplazamiento de 29 € IVA incl. (o el importe confirmado por distancia si fuera superior).</p>
            <p><strong>7.3.</strong> Si, una vez in situ, no es posible actuar por incumplimiento de los requisitos de seguridad (§4) o por negativa del cliente, se aplicará igualmente el forfait de desplazamiento.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Garantías, limitaciones y responsabilidad</h2>
          <div className="space-y-3">
            <p><strong>8.1.</strong> <strong>Responsabilidad del intermediario:</strong> El titular del sitio web actúa exclusivamente como plataforma de intermediación y puesta en contacto. La prestación del Servicio, su calidad, seguridad, plazos y resultados son responsabilidad única y exclusiva del técnico independiente que interviene. El titular del sitio web no responde en ningún caso de los daños, retrasos, incidencias o incumplimientos derivados de la intervención de los técnicos, cuya relación se establece directamente entre el Usuario y el técnico.</p>
            <p><strong>8.2.</strong> El técnico actuará conforme a procedimientos profesionales y equipos adecuados (booster 12 V, protección antipolaridad).</p>
            <p><strong>8.3.</strong> <strong>Limitaciones técnicas:</strong> defectos preexistentes (batería agotada en fin de vida, alternador, motor de arranque, cableados, inmovilizadores, alarmas, accesorios) pueden impedir el arranque o causar nuevas paradas.</p>
            <p><strong>8.4.</strong> <strong>Exención:</strong> ni el titular del sitio web ni el técnico responden de daños derivados de defectos preexistentes del vehículo, de manipulaciones/accesorios del cliente ni de pérdida de ajustes asociada al corte de alimentación, salvo dolo o negligencia grave del técnico interviniente.</p>
            <p><strong>8.5.</strong> <strong>Límite:</strong> salvo dolo/negligencia grave y sin perjuicio de responsabilidades no limitables por ley, la responsabilidad total del técnico por daños directos se limita al importe efectivamente pagado por el cliente por el Servicio correspondiente. El titular del sitio web no asume responsabilidad económica alguna por el Servicio.</p>
            <p><strong>8.6.</strong> <strong>Fuerza mayor:</strong> tráfico extremo, obras, inclemencias, restricciones u otros eventos fuera de control pueden afectar a plazos y ejecución sin generar responsabilidad.</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">9. Recomendaciones posteriores</h2>
          <p>Tras el arranque, se aconseja circular o mantener el motor en marcha el tiempo recomendado para recarga y acudir a taller si persisten anomalías (testigo, nuevos fallos de arranque).</p>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">10. Clientes consumidores</h2>
          <div className="space-y-3">
            <p><strong>10.1.</strong> Derechos de la Ley General para la Defensa de los Consumidores y Usuarios.</p>
            <p><strong>10.2.</strong> <strong>Desistimiento:</strong> al tratarse de un servicio urgente solicitado y que puede completarse antes del plazo legal, el cliente pierde el derecho de desistimiento cuando el Servicio haya sido totalmente ejecutado tras su aceptación. Si estuviera en curso, abonará la parte proporcional ya prestada (ver §7 para desplazamiento).</p>
            <p><strong>10.3.</strong> Hojas oficiales de reclamación (Cataluña) disponibles previa solicitud; información sobre mediación/consumo (OMIC Barcelona).</p>
          </div>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">11. Datos personales</h2>
          <p>El tratamiento se rige por la Política de Privacidad. Finalidades: gestión de la solicitud, prestación del Servicio, facturación y, en su caso, comunicaciones comerciales con consentimiento. Contacto privacidad: rgpd@agencia-ppc.es.</p>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">12. Modificaciones</h2>
          <p>ArrancaYa BCN podrá actualizar estas Condiciones; la versión vigente será la publicada en la web. Los cambios no afectarán a servicios ya contratados y ejecutados.</p>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">13. Nulidad parcial</h2>
          <p>La nulidad de una cláusula no afectará a la validez del resto; se procurará sustituirla por otra válida de efecto equivalente.</p>
        </section>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">14. Legislación y jurisdicción</h2>
          <div className="space-y-3">
            <p><strong>Ley española.</strong></p>
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Consumidores:</strong> fuero del domicilio del consumidor o el imperativo que corresponda.</li>
              <li><strong>No consumidores (B2B):</strong> Juzgados y Tribunales de Barcelona capital.</li>
            </ul>
          </div>
        </section>

        <hr className="border-gray-300" />

        <div className="text-center text-sm text-gray-500 bg-gray-50 p-3 rounded">
          <strong>Última actualización:</strong> 17/09/2026
        </div>
      </div>
    </div>
  );
};